import styled from 'styled-components'

const Label = styled.label.attrs(() => {
    return {
        className: `block text-xxs text-primary-800 ml-4 mb-1`,
    }
})``

export default Label
